export enum TrialAccountRequestFilterType {
  New = 'new',
  Approved = 'approved',
  Declined = 'declined',
}

export type HttpTrialAccountRequestFilters<
  F = TrialAccountRequestFilterType | object | boolean | string | number
> = F | Array<F>;
